import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../state/store";
import { UserAccountRole } from "../../domain/user/account/UserAccountRole";
import { Paths } from "../../Paths";
import { RegistrationStatus, useRegistrationStatus } from "../provider/RegistrationStatusProvider";
import { Loading } from "../view/common/Loading";
import { Navigate, RouteProps } from "react-router-dom";

type Props = {
    children: React.JSX.Element,
}

export function TestDataAdminRouter(props: Props & RouteProps) {
    const { children } = props;
    
    const registered = useRegistrationStatus();
    const auth = useSelector((state: State) => state.auth);

    const routing = () => {
        // User情報がない場合
        if (registered === RegistrationStatus.UNREGISTERED) {
            return <Navigate to={Paths.login} replace/>;
        // User情報が取得中の場合、取得するまで留める
        } else if (registered === RegistrationStatus.PENDING) {
            return <Loading/>;
        }

        // ADMINISTRATORかつproduction以外の場合
        if (auth.role === UserAccountRole.ADMINISTRATOR && process.env.REACT_APP_TEST_PAGE_DISPLAY_FLG === "1") {
            return children; 
        // ADMINISTRATOR以外の場合
        } else {
            return <Navigate to={Paths.root} replace/>;
        }
    };

    return routing();
}
